var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Organization Chart",
    clipPath: "url(#clip0_9814_101102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.16031 11.8403H2.56031V8.32031H7.68031V11.8403H6.08031V15.6803H9.92031V11.8403H8.32031V8.32031H13.4403V11.8403H11.8403V15.6803H15.6803V11.8403H14.0803V7.68031H8.32031V4.16031H10.5603V0.320312H5.44031V4.16031H7.68031V7.68031H1.92031V11.8403H0.320312V15.6803H4.16031V11.8403ZM9.28031 15.0403H6.72031V12.4803H9.28031V15.0403ZM15.0403 15.0403H12.4803V12.4803H15.0403V15.0403ZM6.08031 0.960312H9.92031V3.52031H6.08031V0.960312ZM3.52031 15.0403H0.960312V12.4803H3.52031V15.0403Z",
    fill: "#357EFF",
    stroke: "#357EFF",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9814_101102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.68337903c94dbcb9ae403fe9bbf54236.svg";
export { ForwardRef as ReactComponent };